import React from "react";
import './book-page.css';
import ZeroToOne from '../../Images/books/ZeroToOne.jpg';



const  Review8 = () => {
  return (
            <div className="book-page-box">
                <div class="book-header">
                   <div className="book-img">
                    <img src={ZeroToOne} alt="Zero To One"/>
                   </div>
                   
                   <div class="book-title">
                 <h1>Zero To One</h1> 
                    <p class="author">by <i>Peter Thiel and Blake Masters</i></p>
                      
                    <p>  Book review by <i>Anuradha Singla</i></p>
                        
                </div>
                  
                <div className="blog-para">
                <p>
                    
                    <div className="blog-para">
                    This book is a must read for anyone who aspires to be an entrepreneur. It takes the glam
                    away and gives you the reality check, teaches you about every step that goes into building
                    a successful company but also tells you that there is no guarantee about it being
                    successful at the same time.
                    <br></br><br></br>
                    The author asks <b>What important truth very few people agree with and</b>  answers it through the book by
                    saying that the world would move forward by technology and not globalisation. A startup or a big organization
                    could be profitable in the long run only if it starts to develop new things and not rely on other big companies for
                    it.
                    <br></br>
                    Take the example of Apple. Each year it launches a new better upgraded iphone which excites the user, keeps
                    the organization on toes, and the tech also improves thus the company also grows unlike other smartphone
                    brands.
                
                    <br></br><br></br>
                  
                    <h3>Success comes from luck or skill?</h3>
                    Peter says that we should “reject the unjust tyranny of chance “thus work hard in creating and improving the
                    world step by step, he says that we can have mastery on startups (the success of startups).<br></br>
                    Take for e.g. Elon Musk, Steve Jobs, Jack Dorsey etc. They don’t just have a single company which is successful but
                    many, thus he says that success stems more from skill and while luck is important like warren buffett considers
                    himself a “member of the lucky sperm club”, skills take a higher precedence.
                    <br></br><br></br>
                    
                    <h3>Power law:</h3> 
                    exponential equations show severely unequal distribution.<br></br>
                    Venture capitalists when investing only 2-3 companies are able to make up the loss of the rest because the
                     don’t realise the power law they spend more time and energy on the companies which are going to
                    fail instead they should pick only 5-6 companies and give them all the needful resources and help they might
                    need. This law is not just about investors but also for founders who should think whether the market they are
                    entering into will be worth it in the future.<br></br><br></br>
              
                    
                    The business version of our question in the first chapter would be <b>what valuable company nobody is
                    building</b>. According to Ted Kaczynski there are 3 types of problems in the world easy, hard and impossible,
                    the hard problems or questions have already been asked thus only easy and impossible ones are yet to be
                    found which won’t give the satisfaction as much as hard ones would as easy ones a child could also solve and
                    the impossible can’t be solved so no one works hard to find the hard problems anymore as they believe there
                     none left which is where lies the secret to a valuable company it’s not like there are no hard problems yet to
                    be solved we aren’t just curious enough. Every entrepreneur should plan to be the last mover in her particular
                    market and ask yourself what the world will look like in 10-20 years and how would their business fit in it.
                    <br></br><br></br>
                    
                    <b>A startup messed up at it’s foundation cannot be fixed</b> like if the founders choose wrong partners or hire
                    the wrong people. As a founder it’s one's first job to get things right because one cannot build a great
                    company based on a flawed foundation. As a general rule everyone you involve with your company should be
                    involved full-time, thus they should be properly compensated not necessarily through dollars but equity is
                    better as it encourages the employee to create a value for themselves. Equity is the best way for a founder to
                    keep everyone in the company broadly aligned.
                    <br></br><br></br>
                    
                    <b>Hire people who are not just talented but also excited to be working at your company.</b> From the outside
                    everyone in your company should be different in the same way. On the inside, every individual should be
                    sharply distinguished by her work, making every person in the company responsible for doing just one thing. It
                    would reduce conflict, make management easier, eliminate competition : thus eliminating internal conflicts
                    within the company.
                      
                        <br></br><br></br>
                  
                    <b>Customers won’t come just because you built a product, you need to sell it as well.</b> The work of a
                    salesman can’t be evaluated the same way of an engineer. People overestimate the overall difficulty an
                    engineer faces because it is an obvious one as compared to a salesman, but it takes hard work to make sales
                    look easy. The work of a salesman is to change surface appearances without changing the underlying reality,
                    which strikes engineers as trivial. All salesmen are actors. Your company needs to sell more than just the
                    product to its customers, employees and investors.Exaggerating your own uniqueness is an easy way to botch
                    the monopoly question. The best sales is hidden, there’s nothing wrong with a CEO who can sell, but if he
                    actually looks like a salesman, he’s probably bad at sales and worse at tech.
                    </div>
                    </p>


                        </div>
                        </div>
                        </div>


                         
  );
}

export default Review8;
